import { IconClock, Tooltip } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { Recurrence } from 'typings'
import { Tag } from 'ui'
import { messages } from '../../messages'
import styles from './style.css'

type Props = {
  recurrence: Recurrence | undefined
}

export function RecurrenceTag(props: Props) {
  const { formatMessage, formatDate, formatList } = useIntl()
  const { recurrence } = props
  const hasRecurrence =
    recurrence?.timeIntervals.length || recurrence?.weekdays.length

  if (!hasRecurrence) return null

  const mountWeekdays = () =>
    formatList(
      recurrence?.weekdays.map((day) =>
        formatMessage({
          ...messages.scheduling.weekdays[day],
        })
      ) ?? []
    )

  const mountTimeIntervals = () =>
    formatList(
      recurrence?.timeIntervals.map((timeInterval) =>
        formatMessage(
          { ...messages.scheduling.timeRange },
          {
            start: formatDate(timeInterval.start, {
              timeStyle: 'short',
            }),
            end: formatDate(timeInterval.end, {
              timeStyle: 'short',
            }),
          }
        )
      ) ?? []
    )

  const processTooltip = () => {
    const weekdays = mountWeekdays()
    const timeIntervals = mountTimeIntervals()

    if (weekdays.length && timeIntervals.length) {
      return formatMessage(messages.scheduling.description, {
        weekdaysList: weekdays,
        timeRangeList: timeIntervals,
      })
    }

    if (!weekdays.length) {
      return timeIntervals
    }

    return weekdays
  }

  return (
    <Tooltip text={processTooltip()}>
      <Tag className={styles.recurrenceTag} data-testid="recurrence-tag">
        <IconClock size="small" />
      </Tag>
    </Tooltip>
  )
}
